<template>
  <div>
    <bread-cump :cumps="$route.meta.breadcrumps" :params="$route.params" />

    <v-container fluid>
      <v-row class="ml-3">
        <h4>Month : {{ $route.params.month }}</h4>
        <h4 class="ml-3">Year : {{ $route.params.year }}</h4>
      </v-row>
      <v-row>
        <v-col lg="12">
          <v-card class="card--shadow">
            <list :homeVisitData="homeVisitData" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import List from "@/components/home-visit/List";
import { mapState } from "vuex";
import BreadCump from "@/components/navigation/BreadCump";
export default {
  components: {
    List,
    BreadCump,
  },
  computed: {
    ...mapState("HomeVisit", ["homeVisitData"]),
  },
  created() {
    this.$store.dispatch("HomeVisit/getAll", {
      month: this.$route.params.month,
      year: this.$route.params.year,
      township_id: this.$route.params.township_id,
      // township_id: this.$route.query.township,
    });
  },
};
</script>
